import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Header.css';

export default function Header() {
    const { cartCount, setCartOpen } = useCart();
    const location = useLocation();

    return (
        <header className="site-header">
            <Link to="/" className="header-logo-link">
                <img src="/2B55699D-C82C-4115-9771-14E9E64B1981.png" alt="DEENACTIVE" className="header-logo" draggable="false" />
            </Link>

            <nav className="header-nav">
                <Link to="/shop" className={`header-nav-link${location.pathname === '/shop' ? ' active' : ''}`}>
                    Shop
                </Link>
            </nav>

            <button className="cart-trigger" onClick={() => setCartOpen(true)} aria-label="Warenkorb öffnen">
                <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
                    <line x1="3" y1="6" x2="21" y2="6" />
                    <path d="M16 10a4 4 0 01-8 0" />
                </svg>
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </button>
        </header>
    );
}
